import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import removeSpacing from '../utils/removeSpace.js';
import MobileSliderElements from './elements/MobileSliderElements';
import { HomeCarousel } from './styles/index'

class MobileSlider extends Component {
	constructor(props) {
		super(props);
		this.state = {
			thumbnails: [],
			clickCounter: 0,
			randomNum: 0,
			setCarousel: null,
			loading: true
		};
	}

	componentDidMount() {
		this.stripIframe();
		this.setCarousel = setInterval(() => {
			this.onClick();
		}, 8000);
	}

	componentWillUnmount() {
		clearInterval(this.setCarousel);
	}

	onClick = () => {
		let newNum;
		if (this.state.randomNum < this.props.homepageMobilePosts.length - 1) {
			let prevNum = this.state.randomNum;
			newNum = prevNum += 1;
		} else {
			newNum = 1;
		}

		this.setState(prevState => {
			return {
				clickCounter: prevState.clickCounter += 1,
				randomNum: newNum,
				justClicked: true,
				fadeIn: 'fadeMeIn',
				loading: true
			}
		});

		clearInterval(this.setCarousel);

		this.setCarousel = setInterval(() => {
			this.onClick();
		}, 8000);
	};

	onClickPrev = () => {
		let newNum;
		if (this.state.randomNum >= 1) {
			let prevNum = this.state.randomNum;
			newNum = prevNum -= 1;
		} else {
			newNum = this.props.homepageMobilePosts.length - 1;
		}

		this.setState(prevState => {
			return {
				clickCounter: (prevState.clickCounter += 1),
				randomNum: newNum,
				justClicked: true,
				fadeIn: 'fadeMeIn',
				loading: true
			}
		});

		clearInterval(this.setCarousel);

		this.setCarousel = setInterval(() => {
			this.onClick();
		}, 8000);
	};

	stripIframe = (element) => {
		if (element) {
			let iframe = element;
			var src = iframe.split('src="')[1].split(/[ >]/)[0];
			src = src.slice(0, -1);
			return src;
		}
	};

	render() {

		let mobileThumbs = this.props.homepageMobilePosts.map((post, index) => {
			let postInfo = {
				title: post.fields.postToLinkTo.fields ? post.fields.postToLinkTo.fields.title : '',
				thumb: post.fields.mediaAsset.fields.file.url,
				background: post.fields.backgroundColor || '',
				randomAsset: post.fields.mediaAsset.fields.file.url
			};

			return postInfo;
		});

		let setBackgroundColor;
		if (mobileThumbs[this.state.randomNum] !== undefined) {
			setBackgroundColor = mobileThumbs.length ? mobileThumbs[this.state.randomNum].background : 'white';
		}

		return (
			<HomeCarousel style={{ backgroundColor: setBackgroundColor }}>
				<div onClick={this.onClickPrev} className="next" />
				<div onClick={this.onClick} className="previous" />
				<Link
					to={
						`/project/` +
						removeSpacing(
							mobileThumbs.length && mobileThumbs[this.state.randomNum] !== undefined
								? mobileThumbs[this.state.randomNum].title
								: ''
						)
					}
				>
					<div className="current--thumb">
						{mobileThumbs.length > 1 && (
							<MobileSliderElements
								isLoading={this.state.loading}
								thumbnailsArray={mobileThumbs}
								hideSpinner={this.hideSpinner}
								randomNum={this.state.randomNum}
							/>
						)}
					</div>
				</Link>
			</HomeCarousel>
		);
	}
}

export default MobileSlider;



// WEBPACK FOOTER //
// ./src/Posts/MobileSlider.js